import FilterSelect from '@/components/filters/FilterSelect';
import SummaryCard from '@/components/cards/SummaryCard';
import BarChart from '@/components/charts/BarChart';
import GenderLegend from '../components/GenderLegend';
import { SummaryData, TimeRange } from '../constants/types';

interface Props {
  userSummaryData: SummaryData[];
  userChartData: any[];
  userTimeRange: TimeRange;
  setUserTimeRange: (v: TimeRange) => void;
  timeRangeOptions: any[];
}

const UsersSection: React.FC<Props> = ({
  userSummaryData,
  userChartData,
  userTimeRange,
  setUserTimeRange,
  timeRangeOptions,
}) => (
  <div className="bg-white p-10 rounded-[24px] space-y-8">
    <div className="flex items-center justify-between">
      <h2 className="text-[32px] font-[700]">Users</h2>
      <div className="flex space-x-2">
        <GenderLegend />
        <FilterSelect value={userTimeRange} onChange={(e) => setUserTimeRange(e.target.value)} options={timeRangeOptions} />
      </div>
    </div>
    <div className="grid grid-cols-4 gap-4">
      {userSummaryData.map((d) => (
        <SummaryCard key={d.label} {...d} />
      ))}
    </div>
    <BarChart data={userChartData} />
  </div>
);

export default UsersSection;
